import React, { MouseEventHandler } from "react"

import Tab from "../Tab"
import Tabs from "../Tabs"

const NodeTipCodeSnippet = () => {
  return (
    <pre>
      <code>
        {`let supertokens = require(“supertokens-node”);\n\nsupertokens.init({\n  supertokens: {\n    connectionURI: `}
        <span className="setup-tooltip-code-highlight">{"<YOUR_CONNECTION_URI_HERE>"}</span>
        {`,\n    apiKey: `}
        <span className="setup-tooltip-code-highlight">{"<YOUR_API_KEY_HERE>"}</span>
        {`\n  },\n  appInfo: {…},\n  recipeList: […]\n});`}
      </code>
    </pre>
  )
}

const GolangTipCodeSnippet = () => {
  return (
    <pre>
      <code>
        {`supertokens.Init(supertokens.TypeInput\n  Supertokens: &supertokens.ConnectionInfo{\n    ConnectionURI: `}
        <span className="setup-tooltip-code-highlight">{"<YOUR_CONNECTION_URI_HERE>"}</span>
        {`,\n    APIKey: `}
        <span className="setup-tooltip-code-highlight">{"<YOUR_API_KEY_HERE>"}</span>
        {`,\n  },\n  AppInfo: supertokens.AppInfo{...},\n  RecipeList: []supertokens.Recipe{...},\n})`}
      </code>
    </pre>
  )
}

const PythonTipCodeSnippet = () => {
  return (
    <pre>
      <code>
        {`from supertokens_python import init, InputAppInfo, SupertokensConfig\n\ninit(\n  app_info=InputAppInfo(...),\n  supertokens_config=SupertokensConfig(\n    connection_uri='`}
        <span className="setup-tooltip-code-highlight">{"<YOUR_CONNECTION_URI_HERE>"}</span>
        {`',\n    api_key='`}
        <span className="setup-tooltip-code-highlight">{"<YOUR_API_KEY_HERE>"}</span>
        {`'\n  ),\n  framework='...',\n  recipe_list=[...]\n)`}
      </code>
    </pre>
  )
}

// Show all snippets as tabs
const TipCodeSnippets = () => {
  return (
    <>
      <Tabs
        tabs={{
          node: "NodeJS",
          go: "Golang",
          py: "Python"
        }}
        savePreferredTabLSId="tip-code-snippet"
      >
        <Tab name="node">
          <NodeTipCodeSnippet />
        </Tab>
        <Tab name="go">
          <GolangTipCodeSnippet />
        </Tab>
        <Tab name="py">
          <PythonTipCodeSnippet />
        </Tab>
      </Tabs>
    </>
  )
}

export default TipCodeSnippets
